// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  position: relative;
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 1.5rem;
  background-color: var(--color-neutral);
  background-size: 800px 800px;
  background-position: top left;
  background-repeat: repeat;
}

.login-page__topbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 0.65rem;
  padding: max(0.75rem, env(safe-area-inset-top, 0px))
    max(0.75rem, env(safe-area-inset-right, 0px))
    0.75rem
    max(0.75rem, env(safe-area-inset-left, 0px));
  pointer-events: none;
}

.login-page__topbar > * {
  pointer-events: auto;
  flex-shrink: 0;
}

.login-page__topbar-actions {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.login-page__back {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.55rem 0.85rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow);
  color: var(--color-text);
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.login-page__back:hover:not(:disabled) {
  background: var(--color-accent-soft);
}

.login-page__back:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.login-page__back-icon {
  width: 18px;
  height: 18px;
  display: block;
}

@media (max-width: 480px) {
  .login-page__topbar {
    gap: 0.5rem;
    padding: max(0.65rem, env(safe-area-inset-top, 0px))
      max(0.65rem, env(safe-area-inset-right, 0px))
      0.65rem
      max(0.65rem, env(safe-area-inset-left, 0px));
  }

  .login-page__topbar-actions {
    gap: 0.5rem;
  }
}

.login-page__shell {
  position: relative;
  z-index: 1;
  width: min(100%, 420px);
}

.login-page__brand {
  text-align: center;
  margin-bottom: 1.5rem;
}

.login-page__logo {
  display: grid;
  place-items: center;
  width: 96px;
  height: 96px;
  margin: 0 auto 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: #ffffff;
  box-shadow: var(--shadow);
  overflow: hidden;
}

.login-page__logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.login-page__brand h1 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--color-text);
}

.login-page__brand p {
  margin: 0.2rem 0 0;
  color: var(--color-text-muted);
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.login-page__card {
  padding: 1.5rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow);
}

.login-page__card h2 {
  margin: 0 0 0.35rem;
  font-size: 1.15rem;
  font-weight: 700;
}

.login-page__subtitle {
  margin: 0 0 1.25rem;
  color: var(--color-text-muted);
  font-size: 0.88rem;
  line-height: 1.45;
}

.login-page__field.data-page__modal-field {
  margin-bottom: 0.85rem;
}

.login-page__field-control {
  position: relative;
}

.login-page__field-control input {
  width: 100%;
  padding-left: 2.65rem;
}

.login-page__field-control--password input {
  padding-right: 2.75rem;
}

.login-page__field-icon {
  position: absolute;
  top: 50%;
  left: 0.9rem;
  transform: translateY(-50%);
  display: inline-flex;
  width: 18px;
  height: 18px;
  color: var(--color-text);
  pointer-events: none;
}

.login-page__field-icon svg,
.login-page__field-icon .app-icon {
  width: 18px;
  height: 18px;
  color: var(--color-text);
}

.login-page__toggle-password {
  position: absolute;
  top: 50%;
  right: 0.65rem;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--color-text);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.login-page__toggle-password:hover {
  color: var(--color-text);
  background: var(--color-accent-soft);
}

.login-page__toggle-password svg,
.login-page__toggle-password .app-icon {
  width: 18px;
  height: 18px;
  color: var(--color-text);
}

.login-page__submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  width: 100%;
  padding: 0.85rem 1.1rem;
  border: none;
  border-radius: var(--radius);
  background: var(--color-btn);
  color: var(--color-btn-text);
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: filter 0.2s ease, background 0.2s ease;
}

.login-page__submit:hover:not(:disabled) {
  filter: brightness(1.08);
  background: var(--color-btn-hover);
}

.login-page__submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.login-page__submit svg {
  width: 16px;
  height: 16px;
}

.login-page__footer {
  margin-top: 1.25rem;
  text-align: center;
}

.login-page__footer p {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.78rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;EACZ;;;gDAG8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;EACvC,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX;;;kDAG8C;EAChD;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;EACrC,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB","sourcesContent":[".login-page {\n  position: relative;\n  min-height: 100vh;\n  display: grid;\n  place-items: center;\n  padding: 1.5rem;\n  background-color: var(--color-neutral);\n  background-size: 800px 800px;\n  background-position: top left;\n  background-repeat: repeat;\n}\n\n.login-page__topbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  gap: 0.65rem;\n  padding: max(0.75rem, env(safe-area-inset-top, 0px))\n    max(0.75rem, env(safe-area-inset-right, 0px))\n    0.75rem\n    max(0.75rem, env(safe-area-inset-left, 0px));\n  pointer-events: none;\n}\n\n.login-page__topbar > * {\n  pointer-events: auto;\n  flex-shrink: 0;\n}\n\n.login-page__topbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.login-page__back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.55rem 0.85rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface-raised);\n  box-shadow: var(--shadow);\n  color: var(--color-text);\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.login-page__back:hover:not(:disabled) {\n  background: var(--color-accent-soft);\n}\n\n.login-page__back:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.login-page__back-icon {\n  width: 18px;\n  height: 18px;\n  display: block;\n}\n\n@media (max-width: 480px) {\n  .login-page__topbar {\n    gap: 0.5rem;\n    padding: max(0.65rem, env(safe-area-inset-top, 0px))\n      max(0.65rem, env(safe-area-inset-right, 0px))\n      0.65rem\n      max(0.65rem, env(safe-area-inset-left, 0px));\n  }\n\n  .login-page__topbar-actions {\n    gap: 0.5rem;\n  }\n}\n\n.login-page__shell {\n  position: relative;\n  z-index: 1;\n  width: min(100%, 420px);\n}\n\n.login-page__brand {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.login-page__logo {\n  display: grid;\n  place-items: center;\n  width: 96px;\n  height: 96px;\n  margin: 0 auto 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: #ffffff;\n  box-shadow: var(--shadow);\n  overflow: hidden;\n}\n\n.login-page__logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.login-page__brand h1 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--color-text);\n}\n\n.login-page__brand p {\n  margin: 0.2rem 0 0;\n  color: var(--color-text-muted);\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.login-page__card {\n  padding: 1.5rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface-raised);\n  box-shadow: var(--shadow);\n}\n\n.login-page__card h2 {\n  margin: 0 0 0.35rem;\n  font-size: 1.15rem;\n  font-weight: 700;\n}\n\n.login-page__subtitle {\n  margin: 0 0 1.25rem;\n  color: var(--color-text-muted);\n  font-size: 0.88rem;\n  line-height: 1.45;\n}\n\n.login-page__field.data-page__modal-field {\n  margin-bottom: 0.85rem;\n}\n\n.login-page__field-control {\n  position: relative;\n}\n\n.login-page__field-control input {\n  width: 100%;\n  padding-left: 2.65rem;\n}\n\n.login-page__field-control--password input {\n  padding-right: 2.75rem;\n}\n\n.login-page__field-icon {\n  position: absolute;\n  top: 50%;\n  left: 0.9rem;\n  transform: translateY(-50%);\n  display: inline-flex;\n  width: 18px;\n  height: 18px;\n  color: var(--color-text);\n  pointer-events: none;\n}\n\n.login-page__field-icon svg,\n.login-page__field-icon .app-icon {\n  width: 18px;\n  height: 18px;\n  color: var(--color-text);\n}\n\n.login-page__toggle-password {\n  position: absolute;\n  top: 50%;\n  right: 0.65rem;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--color-text);\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.login-page__toggle-password:hover {\n  color: var(--color-text);\n  background: var(--color-accent-soft);\n}\n\n.login-page__toggle-password svg,\n.login-page__toggle-password .app-icon {\n  width: 18px;\n  height: 18px;\n  color: var(--color-text);\n}\n\n.login-page__submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.55rem;\n  width: 100%;\n  padding: 0.85rem 1.1rem;\n  border: none;\n  border-radius: var(--radius);\n  background: var(--color-btn);\n  color: var(--color-btn-text);\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: filter 0.2s ease, background 0.2s ease;\n}\n\n.login-page__submit:hover:not(:disabled) {\n  filter: brightness(1.08);\n  background: var(--color-btn-hover);\n}\n\n.login-page__submit:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.login-page__submit svg {\n  width: 16px;\n  height: 16px;\n}\n\n.login-page__footer {\n  margin-top: 1.25rem;\n  text-align: center;\n}\n\n.login-page__footer p {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.78rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
